import { useGetExternalAppName } from '@user/store/authorization/hooks/useGetExternalAppName'

export function useMatchLocationTitles() {
  const externalAppName = useGetExternalAppName()

  const matchLocationTitle = externalAppName
    ? `Match to Existing ${externalAppName} Account`
    : 'Match to Existing Location'

  const locationsTitle = `${
    externalAppName ? externalAppName + ' ' : ''
  }Locations`

  return {
    locationsTitle,
    matchLocationTitle,
  }
}
